"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withinSameFrontendApp = exports.isOnAtmsWebUi = exports.nonAtmsWebUiPaths = void 0;
// TODO: autogenerate this from the atms-web-ui-infra cloudfront config
exports.nonAtmsWebUiPaths = ['/tb', '/tickets', '/web/tickets', '/invoices'];
exports.isOnAtmsWebUi = () => !exports.nonAtmsWebUiPaths.some(path => path == location.pathname || location.pathname.startsWith(path));
exports.withinSameFrontendApp = (path1, path2) => {
    for (const prefix of exports.nonAtmsWebUiPaths) {
        const path1HasPrefix = path1 == prefix || path1.startsWith(prefix) + '/';
        const path2HasPrefix = path2 == prefix || path2.startsWith(prefix) + '/';
        if (path1HasPrefix != path2HasPrefix)
            return false; // only one path is on this frontend app
    }
    return true; // paths are on the same app (prefix above or atms-web-ui catch-all)
};
//# sourceMappingURL=frontendApps.js.map